module.exports = __webpack_public_path__ + "static/media/Sky_Italia_-_Logo_2018.6a7f97bc.svg";